import { IHubEventBasicFormFilesState } from './contracts'

export const UPDATE_EVENT_FILES = 'CHANGE_HUB_EVENT_BASIC_FORM_FILES'
export const RESET_EVENT_FILES = 'RESET_EVENT_FILES'

const changeEventFiles = (eventFiles: IHubEventBasicFormFilesState): any => {
  return {
    type: UPDATE_EVENT_FILES,
    payload: eventFiles
  }
}

const resetEventFiles = (eventFiles?: IHubEventBasicFormFilesState): any => {
  return {
    type: RESET_EVENT_FILES,
    payload: eventFiles
  }
}

export { changeEventFiles, resetEventFiles }
